import objectsTemplate from './objects.html';

export default angular
  .module('main.organizations.edit.tabs.objects', [])

  .directive('editOrganizationObjectsTab', () => {
    return {
      restrict: 'E',
      template: objectsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $filter,
                   utils,
                   EditOrganizationDataProvider) => {
        const $t = $filter('translate');
        $scope.dataProvider = EditOrganizationDataProvider.instance;

        angular.extend($scope, {
          parsePropertyName: parsePropertyName,
          back: back,
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.organizationPropsResource.init(),
          ])
            .then(() => {
              initViewModel();

              $scope.$watch('dataProvider.organizationPropsResource.value', () => {
                initViewModel();
              }, true);

              $scope.loading = false;
            }, () => {
              $scope.loading = false;
            });
        }

        function initViewModel() {
          const objects = $scope.dataProvider.organizationPropsResource.value || [];
          $scope.organizationProps = objects.map(el => {
            el.bots = el.name && el.name.startsWith('bot.');
            return el;
          });
        }

        function parsePropertyName(name) {
          if (!name) {
            return $t('notifications.info.unknown-prop');
          }
          return utils.parsePropertyString(name);
        }

        function back() {
          $scope.dataProvider.activeTab = 'settings';
        }

      }
    };
  })
  .name;
